import React, { useCallback, useState } from "react";
import { Modal } from "components/Modal/Modal";
import { Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { useGMC } from "hooks/useGMC";

export function GlobalMarginCallClose() {
  const { close } = useGMC();
  const history = useHistory();
  const { t } = useTranslation();
  const [isSending, setIsSending] = useState(false);
  const { id, marginCallId } = useParams<{
    id: string;
    marginCallId: string;
  }>();

  const handleClose = useCallback(() => {
    history.push(`/companies/${id}`);
  }, [history, id]);

  const closeMarginCall = useCallback(async () => {
    setIsSending(true);

    const success = await close(id, marginCallId);

    if (success) {
      handleClose();
    }
  }, [close, handleClose, id, marginCallId]);

  return (
    <Modal
      confirmText={t("Yes")}
      design="danger"
      isDisabled={isSending}
      isOpen
      onClose={handleClose}
      onConfirm={closeMarginCall}
      title={t(`marginCall:Close Global Margin Call {{marginCallId}}`, {
        marginCallId,
      })}
    >
      <Box mb={"20px"}>
        {t(`marginCall:This action can't be undone. Are you sure you want to close Margin Call {{marginCallId}}?`, {
          marginCallId,
        })}
      </Box>
    </Modal>
  );
}
